import React, { useEffect, useState } from 'react';
import { useSearchParams, useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { AnimatePresence, m } from 'framer-motion';
import useEncounter from 'hooks/useEncounter';
import { FLAGS, useFlags } from 'hooks/useFlags';

import './Dialog.scss';
import { AudioPlayer } from 'components/Audio/Audio';
import { routes } from '../../routing/routes';

export default function Dialog() {
  let { slug } = useParams();
  const [searchParams] = useSearchParams();
  const { encounter, isLoading } = useEncounter(slug);
  const [displayPage, setDisplayPage] = useState(1);
  const { isFlagEnabled, isReady: isFlagReady } = useFlags();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.get('page')) {
      console.log('setting value');
      setDisplayPage(Number(searchParams.get('page')));
      console.log();
    }
    if (searchParams.get('page') === '0') {
      if (isFlagEnabled(FLAGS.hatchening)) {
        navigate(routes.adrianSanctuary());
      } else {
        navigate(routes.stories());
      }
    }
  }, [searchParams, navigate, isFlagReady, isFlagEnabled]);

  function renderSelectedPage() {
    return (
      <div key={encounter.title}>
        {encounter.dialog
          .filter((item) => item.page === displayPage)
          .map(({ dialog, prompts, fontsize, fillcolor, strokecolor, fontcolor, character }) => {
            return (
              <div id="dialog-contain" key={'encpage' + encounter.page}>
                <div className="bubble-hold">
                  <m.blockquote
                    className="bubble"
                    style={{}}
                    initial={{ opacity: 0.5 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0.5 }}
                    transition={{ duration: 0.2 }}
                  >
                    <span
                      className="bubble-inner"
                      style={{
                        fontSize: fontsize ? fontsize : '1rem',
                        color: fontcolor ? fontcolor : 'black',
                      }}
                    >
                      <span className="bubble-inner-wrap">{dialog}</span>
                    </span>
                    <svg
                      className="chat"
                      viewBox="-82 -55 164 110"
                      xmlns="http://www.w3.org/2000/svg"
                      preserveAspectRatio="none"
                    >
                      <path
                        style={{
                          fill: fillcolor ? fillcolor : 'white',
                          stroke: strokecolor ? strokecolor : 'black',
                        }}
                        d="M-80, 0
                            Q-80,-50   0,-50
                            Q 80,-50  80,  0
                            Q 80, 50   0, 50
                            Q-80, 50 -80,  0
                            Z"
                      />
                    </svg>
                    <svg className="pointbody">
                      <polygon
                        style={{ fill: fillcolor ? fillcolor : 'white' }}
                        points="4,44 50,0 100,0"
                      />
                    </svg>
                    <svg className="pointstroke">
                      <polygon
                        style={{
                          fill: fillcolor ? fillcolor : 'white',
                          stroke: strokecolor ? strokecolor : 'black',
                        }}
                        points="4,44 50,0 100,0"
                      />
                    </svg>
                  </m.blockquote>
                </div>

                <div id="dialog-composite">
                  <div style={{ backgroundImage: `url(${encounter.bgUrl})` }} id="dialog-bg"></div>

                  {encounter.fgUrl && (
                    <div
                      style={{ backgroundImage: `url(${encounter.fgUrl})` }}
                      id="dialog-fg"
                    ></div>
                  )}

                  <div id="dialog-content">
                    {encounter.bgMusic && <AudioPlayer audioSource={encounter.bgMusic} />}
                    <AnimatePresence exitBeforeEnter>
                      {encounter.characters
                        .filter((item) => item.fields.title === character)
                        .map(({ fields }) => {
                          return (
                            <m.img
                              key={fields.title}
                              src={fields.file.url}
                              style={{}}
                              className="dialog-character"
                              alt={fields.description}
                              initial={{ opacity: 0.5 }}
                              animate={{ opacity: 1 }}
                              exit={{ opacity: 0.5 }}
                              transition={{ duration: 0.2 }}
                            />
                          );
                        })}
                    </AnimatePresence>
                  </div>
                </div>

                <div className="dialog-options">
                  {prompts.map((val) => {
                    return (
                      <Link
                        key={'pagechoice' + val.page}
                        className="btn btn-primary btn-sm"
                        to={`?page=${val.page}`}
                      >
                        {val.prompt}
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          })}
      </div>
    );
  }

  const imagesToPreload = encounter?.characters.map(({ fields }) => (
    <link rel="preload" as="image" href={fields.file.url} key={fields.file.url} />
  ));

  return (
    <>
      <Helmet>
        <title>Dialog - DuskBreakers</title>
        <meta name="description" content="Test." />
        {encounter && <link rel="preload" as="image" href={encounter.bgUrl} />}
        {imagesToPreload}
      </Helmet>

      {!isLoading && renderSelectedPage()}
    </>
  );
}
